import Vue from 'vue';
import config from '../../config/index.js';

export default {
  // 模糊搜索企业列表
  getOrgListByName(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysOrg/listByName?orgName=${params}`);
  },
  // 申请试用 
  postTrialUser(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysTrialUser/add`, params);
  },
  // 找回密码（修改密码） 
  findPassword(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysUser/forgetPassword`, params);
  },
  // 根据机构名称获取机构下的子系统列表 
  getSysAppList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysOrg/appList?orgName=${params}`);
  },
  // 注册用户 
  postRegister(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysUser/register`, params);
  }
};